export { FooterProps } from './footer.props';
export const name = "FooterComponent";
